
import BoneAccordions from './bone-accordion';

/* SLIDE UP */
const slideUp = (target, content, duration = 300) => {
	if(!target || !content)
	{
		return;
	}

	// if(content.style)
	// {
	// 	// content.style.transform = 'translateY(15px)';
	// 	content.style.opacity = '0';
	// }

	// target.style.maxHeight = 0;

	// window.setTimeout( () => {
	// 	content.style.transform = 'translateY(1rem)';
	// }, duration);

	requestAnimationFrame(() => {
		if(content.style)
		{
			// content.style.transform = 'translateY(15px)';
			content.style.opacity = '0';
		}

		target.style.maxHeight = 0;

		window.setTimeout( () => {
			requestAnimationFrame(() => {
				content.style.transform = 'translateY(1rem)';
			})
		}, duration);
	});


	// window.setTimeout( () => {
	// 	target.style.maxHeight = 0;
	// }, duration);
	// }, duration * 0.5);

	// window.setTimeout( () => {
	// 	// target.style.display = 'none';
	// 	// target.style.removeProperty('max-height');
	// }, duration * 1.5);
}

const slideDown = (target, content, duration = 300) => {
	if(!target || !content)
	{
		return;
	}

	// target.style.removeProperty('display');
	// target.style.display = 'block';
	requestAnimationFrame(() => {
		let height = target.scrollHeight;
		target.style.maxHeight = `${height}px`;

		window.setTimeout( () => {
			requestAnimationFrame(() => {
				content.style.transform = 'translateY(0)';
				content.style.opacity = '1';
			})
		}, duration * 0.25);
	})
}

export function accordians() {

	const accs = {
		instances: [],
	};

	const baseClass = 'accordion';

	accs.animateExpand = function(segment) {
		const body = segment.querySelector(`.${baseClass}__segment-body`);
		const content = segment.querySelector(`.${baseClass}__segment-content`);

		slideDown(body, content);
	}

	accs.animateCollapse = function(segment) {
		const body = segment.querySelector(`.${baseClass}__segment-body`);
		const content = segment.querySelector(`.${baseClass}__segment-content`);

		slideUp(body, content);
	}

	accs.animationsInit = function(segment) {
		const body = segment.querySelector(`.${baseClass}__segment-body`);
		const content = segment.querySelector(`.${baseClass}__segment-content`);

		if(body.getAttribute('aria-hidden') === 'false') {
			slideDown(body, content);
		} else {
			slideUp(body, content);
		}
		
	}

	BoneAccordions.init({
		baseClass,
		expandAnimationCB: accs.animateExpand,
		collapseAnimationCB: accs.animateCollapse,
		animationSetupCB: accs.animationsInit,
		openMultiple: false,
	});

	return accs;
}



// WEBPACK FOOTER //
// ./scripts/modules/accordion.js